import React from 'react'
import { injectIntl, defineMessages } from 'react-intl'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import { compose } from 'recompose'
import { loadResultsByTest, clearResults } from '../../common/results/actions'
import { loadTestDetail, clearTestDetail } from '../../common/tests/actions'
import { updateNotification } from '../../common/notifications/actions'
import { BackLink, ResultsList, PageHeader } from '../components'

class ResultsPage extends React.Component {
  componentDidMount() {
    const { loadResultsByTest, match, loadTestDetail, location, updateNotification } = this.props
    const testId = match.params.id
    loadResultsByTest(testId)
    loadTestDetail(testId)
    const notificationId = location.search.split('=').pop()
    if (notificationId) {
      updateNotification(notificationId)
    }
  }
  
  componentWillUnmount() {
    this.props.clearResults()
    this.props.clearTestDetail()
  }

  render() {
    const { intl, results, test, viewer } = this.props

    if (!results || !test) {
      return <span>Loading...</span>
    }

    return (
      <div>
        <BackLink />
        <PageHeader title={`${intl.formatMessage(messages.title)} ${test.name}`} />
        <ResultsList results={results} test={test} />
      </div>
    )
  }
}

ResultsPage.defaultProps = {
  location: null,
  test: null,
  results: [],
  viewer: null,
  match: {},
}

ResultsPage.propTypes = {
  loadResultsByTest: PropTypes.func.isRequired,
  clearResults: PropTypes.func.isRequired,
  loadTestDetail: PropTypes.func.isRequired,
  clearTestDetail: PropTypes.func.isRequired,
  updateNotification: PropTypes.func.isRequired,
  test: PropTypes.object,
  location: PropTypes.object,
  results: PropTypes.array,
  intl: PropTypes.object.isRequired,
  match: PropTypes.object,
  viewer: PropTypes.object,
}

ResultsPage = withRouter(ResultsPage)

const enhance = compose(
  connect(state => ({
    viewer: state.users.viewer,
    results: state.results.all,
    test: state.tests.currentTest,
  }), { loadResultsByTest, clearResults, loadTestDetail, clearTestDetail, updateNotification }),
  injectIntl,
)

export default enhance(ResultsPage)

const messages = defineMessages({
  title: {
    id: 'results.page.title',
    defaultMessage: 'Výsledky testu',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/ResultsPage.js